// import React from "react";

// const colors = [
//   { name: "black", hex: "#000000" },
//   { name: "red", hex: "#EF4444" },
//   { name: "blue", hex: "#3B82F6" },
//   { name: "green", hex: "#22C55E" },
//   { name: "yellow", hex: "#EAB308" },
//   { name: "pink", hex: "#EC4899" },
//   { name: "purple", hex: "#A855F7" },
//   { name: "gray", hex: "#9CA3AF" }
// ];

// const ColorFilter = ({ filters, setFilters }) => {
//   const toggle = (color) => {
//     setFilters((prev) => ({
//       ...prev,
//       colors: prev.colors.includes(color)
//         ? prev.colors.filter((c) => c !== color)
//         : [...prev.colors, color]
//     }));
//   };

//   return (
//     <div>
//       <h4 className="font-medium mb-2">Colors</h4>

//       <div className="flex flex-wrap gap-2">
//         {colors.map((c) => {
//           const isSelected = filters.colors.includes(c.name);

//           return (
//             <button
//               key={c.name}
//               onClick={() => toggle(c.name)}
//               className={`w-6 h-6 rounded-full border-2 transition
//                 ${
//                   isSelected
//                     ? "border-black scale-110"
//                     : "border-gray-300"
//                 }
//               `}
//               style={{ backgroundColor: c.hex }}
//               title={c.name}
//             />
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ColorFilter;

import React from "react";

const ColorFilter = ({ filters, setFilters, colorOptions = [] }) => {
  const toggle = (color) => {
    setFilters((prev) => ({
      ...prev,
      colors: prev.colors.includes(color)
        ? prev.colors.filter((c) => c !== color)
        : [...prev.colors, color]
    }));
  };

  if (!colorOptions.length) return null;

  return (
    <div>
      <h4 className="font-medium mb-3">Colors</h4>

      <div className="flex flex-wrap gap-3">
        {colorOptions.map((c) => {
          const isSelected = filters.colors.includes(c.name);

          return (
            <button
              key={c.name}
              onClick={() => toggle(c.name)}
              title={c.name}
              className={`
                relative w-7 h-7 rounded-full border transition
                ${isSelected ? "ring-2 ring-black ring-offset-2" : "border-gray-300"}
              `}
              style={{ backgroundColor: c.hex }}
            >
              {isSelected && (
                <span className="absolute inset-0 flex items-center justify-center">
                  <svg
                    clasName="w-3 h-3 text-white"
                    fills="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ColorFilter;
